const MACHINE_IDS = {
  CTS_528XL: 6
};

const FOOTPRINT_LABELS = {
  EIGHT_FIVE_BY_SIX_FIVE: '8.5×6.5 Family'
};

const FOOTPRINT_KEYS = {
  EIGHT_FIVE_BY_SIX_FIVE: '8.5×6.5'
};

const COLLECTION_NAMES = {
  EIGHT_FIVE_BY_SIX_FIVE: '8.5" X 6.5" COLLECTION'
};

const SEALING_MACHINE_INCOMPATIBILITIES = [
  {
    machineId: MACHINE_IDS.CTS_528XL,
    disallowFootprints: [FOOTPRINT_KEYS.EIGHT_FIVE_BY_SIX_FIVE],
    disallowFootprintLabels: [FOOTPRINT_LABELS.EIGHT_FIVE_BY_SIX_FIVE],
    disallowCollections: [COLLECTION_NAMES.EIGHT_FIVE_BY_SIX_FIVE]
  }
];

const normalizeCollection = (value) => {
  if (!value) return '';
  return String(value).trim().toLowerCase();
};

const matchesRule = (container, rule) => {
  if (!container) return false;

  const { disallowFootprints = [], disallowFootprintLabels = [], disallowCollections = [] } = rule;

  if (disallowFootprints.length && container.footprint && disallowFootprints.includes(container.footprint)) {
    return true;
  }

  if (
    disallowFootprintLabels.length &&
    container.footprintLabel &&
    disallowFootprintLabels.includes(container.footprintLabel)
  ) {
    return true;
  }

  if (disallowCollections.length && disallowCollections.includes(container.collection)) {
    return true;
  }

  if (disallowCollections.length && normalizeCollection(container.collection)) {
    const normalizedSet = new Set(disallowCollections.map(normalizeCollection));
    if (normalizedSet.has(normalizeCollection(container.collection))) {
      return true;
    }
  }

  return false;
};

export const getIncompatibleSealingMachineIdsForContainers = (containers = []) => {
  const disallowed = new Set();

  if (!Array.isArray(containers) || containers.length === 0) {
    return disallowed;
  }

  const normalizedContainers = containers.filter(Boolean);
  if (!normalizedContainers.length) {
    return disallowed;
  }

  SEALING_MACHINE_INCOMPATIBILITIES.forEach((rule) => {
    const hasConflict = normalizedContainers.some((container) => matchesRule(container, rule));
    if (hasConflict) {
      disallowed.add(rule.machineId);
    }
  });

  return disallowed;
};

export const filterCompatibleSealingMachines = (machines = [], containers = []) => {
  const disallowed = getIncompatibleSealingMachineIdsForContainers(containers);
  if (!disallowed.size) {
    return [...machines];
  }
  return machines.filter((machine) => !disallowed.has(machine.id));
};

export const isSealingMachineAllowedForContainers = (machineId, containers = []) => {
  const disallowed = getIncompatibleSealingMachineIdsForContainers(containers);
  return !disallowed.has(machineId);
};

export const SEALING_MACHINE_IDS = MACHINE_IDS;
